import { ArrowDownIcon } from './ds/icons';

/**
 * Back to the end of a log after scrolling up to read it. Only drawn while
 * the log is not following new lines: at the end it would be a button that
 * does nothing. Pressing it scrolls down and the log follows again.
 */
const JumpToLatestButton = ({ onClick }: { onClick: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    className="b4-focus z-10 absolute bottom-3 right-3 h-[30px] px-3 flex items-center gap-1.5 rounded-full border border-navy-400 bg-navy-700 text-ds-115 font-medium text-navy-100 shadow-[0_6px_18px_rgba(0,0,0,0.45)] hover:bg-navy-600 hover:text-white transition-colors duration-[120ms]"
  >
    <ArrowDownIcon size={13} />
    Latest
  </button>
);

export default JumpToLatestButton;
